export default "__VITE_ASSET__BGsWBRSr__"